import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RequestRialDetailComponent } from './request-rial-detail/request-rial-detail.component';
import { RequestRialComponent } from './request-rial.component';

const routes: Routes = [
  {
    path:'',
    component: RequestRialComponent
  },
  {
    path:'details/:id',
    component: RequestRialDetailComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RequestRialRoutingModule { }
